import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("section", {
        class: _normalizeClass(["row justify-center full-width", {
                'q-py-xl': !_ctx.noPadding,
                ..._ctx.classes
            }])
    }, [
        _createElementVNode("div", {
            style: _normalizeStyle({
                ..._ctx.innerStyle
            }),
            class: _normalizeClass({
                'px-md-lt-md': !_ctx.noSubPadding && !_ctx.fullWidthOnMobile,
                'standard-page-col': !_ctx.customCol && !_ctx.fullWidthOnMobile,
                'full-mobile-width-page-col': !_ctx.customCol && _ctx.fullWidthOnMobile,
                'col-12': _ctx.customCol,
                ..._ctx.innerClass
            })
        }, [
            _renderSlot(_ctx.$slots, "default")
        ], 6)
    ], 2));
}
